import React from 'react';
import './SidebarPage.scss';

export interface SidebarPageProps {
  className?: string;
  children?: React.ReactNode;
}

export const SidebarPage: React.FC<SidebarPageProps> = ({ className, children }) => {
  const classNames = ['sidebar-page', className].join(' ').trim();
  return <div className={classNames}>
    {children}
  </div>;
}
